// export default function BookButton() {
//   return (
//     <a
//       href=
//       onClick={(e) => {
//         if (window.FH && window.FH.open) {
//           e.preventDefault();
//           window.FH.open({
//             shortname: "solsticestudios",
//             fallback: "simple",
//             fullItems: "yes",
//             view: "items",
//           });
//         }
//       }}
//     >
//       Paint & Sip
//     </a>
//   );
// }

// BookButton.jsx
import clsx from "clsx"; // optional helper for combining class names

export default function BookButton({
  label = "Paint & Sip",
  className = "",
  variant = "default",
}) {
  const handleClick = (e) => {
    if (window.FH && window.FH.open) {
      e.preventDefault();
      window.FH.open({
        shortname: "solsticestudios",
        fallback: "simple",
        fullItems: "yes"
      });
    }
  };

  return (
    <a
      href={`https://fareharbor.com/embeds/book/solsticestudios/items/673714/?full-items=yes&flow=1491960`}
      onClick={handleClick}
      className={clsx(
        "inline-block rounded-lg px-4 py-2 font-semibold transition",
        variant === "default" && "bg-[#00CCA5] text-white hover:opacity-90",
        variant === "outline" && "border border-[#00CCA5] text-[#00CCA5] hover:bg-[#00CCA5]/10",
        className
      )}
    >
      {label}
    </a>
  );
}